import { Typography as MuiTypography } from '@mui/material';
import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import type { ElementType, ReactElement } from 'react';

export type TypographyProps<C extends ElementType = 'span'> = MuiTypographyProps<C>;

export const Typography = <C extends ElementType = 'span'>(
  props: TypographyProps<C>,
): ReactElement => <MuiTypography {...props} />;
